import { REQUEST_TYPES } from '../requestTypes';
import { ENTITY_NAMES } from '../entityNames';
import { ENDPOINTS } from '../../../config/config';
import { DASHBOARD_API_URLS } from '../../constants';
import { type RequestHandlerFactory } from '../../types';

const url = DASHBOARD_API_URLS.V2.GAMIFICATION;

export const gamificationRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_GAMIFICATION_SCORE_POINTS]: params => {
        return {
            transformResponse: (res: any) => {
                const results = res?.[ENTITY_NAMES.GAMIFICATION_SCORE_POINTS]?.data;
                return {
                    entities: {
                        [ENTITY_NAMES.GAMIFICATION_SCORE_POINTS]: {
                            items: results?.stats,
                            itemsMeta: results?.paging
                        }
                    }
                };
            },
            descriptors: {
                [ENTITY_NAMES.GAMIFICATION_SCORE_POINTS]: {
                    defaultEndpoint: ENDPOINTS.VF_DASHBOARD_URL,
                    method: 'post',
                    url,
                    data: params
                }
            }
        };
    }
};
